module.exports = __webpack_public_path__ + "img/NoInternetIcon.2c253539.svg";